import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../../components/ProductCard/ProductCard';
import { useProducts } from '../../hooks/useProducts';
import './HomePage.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
const SLIDES = [
  { titre: 'Éclat & Élégance',      sous: 'Bijoux de caractère pour femme moderne',          cta: 'Découvrir les bijoux', lien: '/catalogue/bijoux',    img: '/images/hero/hero-bijoux.jpg'    },
  { titre: 'Transformez votre style',sous: 'Perruques naturelles et styles iconiques',        cta: 'Explorer',             lien: '/catalogue/perruques', img: '/images/hero/hero-perruques.jpg' },
];
const CATEGORIES = [
  { slug: 'bijoux',    label: 'Bijoux',    desc: 'Colliers, bracelets & bagues',        img: '/images/produits/collier-double-chaine.jpg' },
  { slug: 'perruques', label: 'Perruques', desc: 'Lace front, tissages & synthétiques', img: '/images/produits/perruque-lob-ondule.jpg'   },
];

export default function HomePage() {
  useDocumentTitle();

  const [slide, setSlide] = useState(0);
  const [email, setEmail] = useState('');
  const [newsletterMsg, setNewsletterMsg] = useState('');
  const { products: nouveautes, loading } = useProducts({ nouveaute: 1, limit: 4 });
  const { products: tous }               = useProducts({ limit: 4 });
  const produits = nouveautes.length > 0 ? nouveautes : tous;

  useEffect(() => {
    const t = setInterval(() => setSlide(s => (s + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="home">
      <section className="hero" aria-label="Mise en avant">
        <div className="hero__grain" aria-hidden="true" />
        {SLIDES.map((s, i) => (
          <div key={i} className={`hero__slide${i === slide ? ' hero__slide--active' : ''}`} aria-hidden={i !== slide}>
            {s.img && (
              <div className="hero__bg" aria-hidden="true"
                style={{ backgroundImage: `url(${s.img})` }} />
            )}
            <div className="hero__content container">
              <p className="hero__overtitle">Collection 2025 — 2026</p>
              <h1 className="hero__titre">{s.titre}</h1>
              <p className="hero__sous">{s.sous}</p>
              <div className="hero__ctas">
                <Link to={s.lien} className="btn-or">{s.cta}</Link>
                <Link to="/catalogue" className="btn-outline">Tout voir</Link>
              </div>
            </div>
          </div>
        ))}
        <div className="hero__dots" role="tablist">
          {SLIDES.map((_, i) => (
            <button key={i} className={`hero__dot${i === slide ? ' hero__dot--active' : ''}`}
              onClick={() => setSlide(i)} role="tab" aria-selected={i === slide} aria-label={`Slide ${i + 1}`} />
          ))}
        </div>
        <div className="hero__scroll" aria-hidden="true"><span /></div>
      </section>

      <section className="trust" aria-label="Nos garanties">
        <div className="container trust__inner">
          {[
            { icon: '🚚', label: 'Livraison rapide',  desc: '2 à 5 jours ouvrés'            },
            { icon: '🔒', label: 'Paiement sécurisé', desc: 'Stripe — 100% sécurisé'        },
            { icon: '↩️', label: 'Retours faciles',    desc: "14 jours pour changer d'avis"  },
            { icon: '💎', label: 'Qualité garantie',   desc: 'Sélection rigoureuse'           },
          ].map(b => (
            <div key={b.label} className="trust__item">
              <span className="trust__icon" aria-hidden="true">{b.icon}</span>
              <div><p className="trust__label">{b.label}</p><p className="trust__desc">{b.desc}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="section featured" aria-labelledby="featured-titre">
        <div className="container">
          <div className="section__header">
            <p className="section__overtitle">Sélection</p>
            <h2 className="section__titre" id="featured-titre">Nos coups de cœur</h2>
            <hr className="divider-or" />
            <p className="section__sous">Les pièces qui font l'unanimité cette saison</p>
          </div>
          {loading ? <div className="spinner" /> : (
            <div className="products-grid">
              {produits.map(p => <ProductCard key={p.id} produit={p} />)}
            </div>
          )}
          <div className="section__cta">
            <Link to="/catalogue" className="btn-outline">Voir toute la collection</Link>
          </div>
        </div>
      </section>

      <section className="section categories" aria-labelledby="cat-titre">
        <div className="container">
          <div className="section__header">
            <p className="section__overtitle">Explorer</p>
            <h2 className="section__titre" id="cat-titre">Nos univers</h2>
            <hr className="divider-or" />
          </div>
          <div className="categories__grid">
            {CATEGORIES.map(c => (
              <Link key={c.slug} to={`/catalogue/${c.slug}`} className="cat-card">
                <img src={c.img} alt={c.label} className="cat-card__img" loading="lazy" />
                <div className="cat-card__overlay" aria-hidden="true" />
                <div className="cat-card__content">
                  <h3 className="cat-card__titre">{c.label}</h3>
                  <p className="cat-card__desc">{c.desc}</p>
                  <span className="cat-card__cta">Découvrir →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="promo-banner" aria-label="Newsletter">
        <div className="container promo-banner__inner">
          <div className="promo-banner__text">
            <p className="promo-banner__overtitle">Offre limitée</p>
            <h2 className="promo-banner__titre">-20% sur votre première commande</h2>
            <p className="promo-banner__sous">Inscrivez-vous et recevez votre code de réduction.</p>
          </div>
          {newsletterMsg ? (
            <p style={{ color: 'var(--or)', fontFamily: 'var(--font-titre)', fontSize: '1.1rem', maxWidth: 360 }}>{newsletterMsg}</p>
          ) : (
            <form className="promo-banner__form" onSubmit={e => { e.preventDefault(); if (email) { setNewsletterMsg('Merci ! Votre code arrive par email. 🎉'); setEmail(''); } }}>
              <input type="email" placeholder="Votre adresse email" required value={email} onChange={e => setEmail(e.target.value)} aria-label="Email" />
              <button type="submit" className="btn-or">Je m'inscris</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}